import React from "react";
import GoogleChart from "../../../../../components/googleChart/googleChart";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/averageClassSizeByInstructorSagas";

const LineChart = () => {
  const dispatch = useDispatch();
  let {
    chartData: {
      data_table: { cols, rows },
      options
    },
    selectedFilters: { table_view },
    filters: { classTypes: { options: classTypesOptions = [] } = {} }
  } = useSelector((state) => state.averageClassSizeByInstructor);

  const switchView = (view) => dispatch(actionCreators.updateTableView(view));

  return classTypesOptions.length ? (
    <GoogleChart
      chartName="capacity_per_class_chart"
      width="1100px"
      height={400}
      chartType={table_view ? "Table" : "LineChart"}
      isTableView={table_view}
      enableEventListeners
      showAdditionTooltip={false}
      rows={rows}
      columns={cols}
      options={options}
      switchView={switchView}
    />
  ) : (
    <div className="error error--big">No data available</div>
  );
};

export default LineChart;
